const timeTypes = [
  { label: 'Entrada', value: 'arrival' },
  { label: 'Salida', value: 'departure' },
  { label: 'Entrada Colación', value: 'arrival_break_time' },
  { label: 'Salida Colación', value: 'departure_break_time' }
];

export const multiTimeTypes = [
  { label: 'Todos', value: 'all' },
  { label: 'Entrada', value: 'arrival' },
  { label: 'Salida', value: 'departure' },
  { label: 'Entrada Colación', value: 'arrival_break_time' },
  { label: 'Salida Colación', value: 'departure_break_time' }
];

export default timeTypes;
